import BodyText from './bodyText'

export default BodyText